export {
  VERSION,
  APOLLO_URI_DEADPOOL_V3,
  APOLLO_URI_DEADPOOL_V2,
} from '@/utils/constants'
